<p>
  The Last Straw is a 3D physics game built in Unity. I worked with some
  talented friends on this project for Ludum Dare 52.
</p>

<p>
  We had a blast putting it together, and I got a chance to try on some hats I
  don't usually have the leisure to enjoy like writing, production, and level
  design. We were really happy with how it turned out and what we were able to
  put together in such a short time.
</p>
